/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import ReactMarkdown from 'react-markdown';
import { string, func } from 'prop-types';

const useStyles = makeStyles((theme) => ({
    headerText: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        fontWeight: 'bold',
    },
    solidDividerLine: {
        backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
        width: '100%',
        height: '2px',
    },
    headerWrapper: {
    },
    contentWrapper: {
        textAlign: 'center',
    },
    closeIcon: {
        position: 'absolute',
        right: '1%',
        cursor: 'pointer',
    },
    headerTextWrapper: {
        textAlign: 'center',
        width: '100%',
    },
}));

const MoreMoviesModal = ({ modalData, changeModalState }) => {
    const classes = useStyles();
    return (
        <Dialog open={modalData}>
            <DialogTitle className={classes.dialogHeader}>
                <Grid container className={classes.headerWrapper}>
                    <Grid item className={classes.headerTextWrapper}>
                        <Typography className={classes.headerText}>
                            Digital Movie Selection
                        </Typography>
                    </Grid>
                    <Grid item className={classes.closeIconWrapper}>
                        <CloseIcon className={classes.closeIcon} onClick={() => { changeModalState(false); }} />
                    </Grid>
                </Grid>
                <div className={classes.solidDividerLine} />
            </DialogTitle>
            <Grid container className={classes.contentWrapper}>
                <ReactMarkdown source={modalData} className={classes.moreMovies} />
            </Grid>
        </Dialog>
    );
};

MoreMoviesModal.propTypes = {
    changeModalState: func.isRequired,
    modalData: string,
};

MoreMoviesModal.defaultProps = {
    modalData: false,
};

export default MoreMoviesModal;
